import { toCamel } from 'snake-camel';
import { encodeGet, GetObject } from './api';

const popProducts = Array(10)
    .fill(null)
    .map((_, idx) => ({
        article: idx + '1LLE-T80-6-230-30-GX53',
        name: idx + 'Лампа светодиодная T75 таблетка 6Вт 230В 3000К GX53 IEK',
        short_name: idx + 'Лампа LED T75 таблетка 6Вт 230В 3000К GX53 IEK',
        tm: 'IEK',
        description:
            'Светодиодные лампы IEK являются современными источниками света и применяются в осветительных приборах, как альтернативные галогенным лампам с цоколем GU5.3, GU10 и лампам накаливания с цоколем Е14, Е27 источники света.\n\nСветодиодные лампы предназначены для использования в осветительных приборах наружного и внутреннего освещения объектов промышленного, коммерческого и бытового назначения.\n\nСоответствуют требованиям Технических регламентов Таможенного союза ТР ТС 004/2011, ТР ТС 020/2011, МЭК 62560, Постановления Правительства РФ от 19.06.2012 № 602.',
        url: '/modulnoe_oborudovanie/product',
        image_url: '/logo512.png',
        imageVariants: [],
    }));
const features = [
    {
        name: 'Характеристика',
        id: '1',
        value: '200',
        unit: 'шт',
        unit_id: null,
    },
    {
        name: 'Скорость',
        id: '2',
        value: '9000',
        unit: ' км/c',
        unit_id: null,
    },
];
const filters = Array(5)
    .fill(null)
    .map((_, idx) => ({
        id: 'id' + idx,
        name: 'Фильтр' + idx,
        values: [
            {
                value: '1',
                productCount: 100,
            },
            {
                value: '2',
                productCount: 50,
            },
            {
                value: '3',
                productCount: 0,
            },
        ],
    }));
const classes = Array(3)
    .fill(null)
    .map((_, idx) => ({
        id: 'id' + idx,
        name: 'Класс' + idx,
    }));
const categories = [
    {
        name: 'Модульное оборудование',
        products_count: 1117,
        slug: 'modulnoe_oborudovanie',
        imageVariants: [],
        url: '/modulnoe_oborudovanie/',
        imageUrl: '/logo512.png',
        subcategories_products_count: 1117,
        children: [
            {
                name: 'Автоматические выключатели',
                products_count: 1117,
                slug: 'avtomaticheskie_vyklyuchateli',
                imageVariants: [],
                url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/',
                imageUrl: '/logo512.png',
                subcategories_products_count: 0,
                children: [
                    {
                        name: 'Автоматические выключатели KARAT',
                        products_count: 1117,
                        slug: 'avtomaticheskie_vyklyuchateli_karat',
                        imageVariants: [],
                        description: 'блабла',
                        seoText: '<h2>Заголовок</h2><p>Текст</p>',
                        url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/',
                        imageUrl: '/logo512.png',
                        subcategories_products_count: 1117,
                        children: [],
                    },
                ],
            },
        ],
    },
];
const methods: any = {
    '/categories/': {
        categories: [
            {
                name: 'Модульное оборудование',
                products_count: 1117,
                slug: 'modulnoe_oborudovanie',
                imageVariants: [],
                url: '/modulnoe_oborudovanie/',
                image_url: '/logo512.png',
                subcategories_products_count: 1117,
                children: [
                    {
                        name: 'Автоматические выключатели',
                        products_count: 1117,
                        imageVariants: [],
                        slug: 'avtomaticheskie_vyklyuchateli',
                        url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/',
                        image_url: '/logo512.png',
                        subcategories_products_count: 120,
                        children: null,
                    },
                ],
            },
            {
                name: '02. Силовое оборудование защиты и коммутации',
                slug: 'so',
                imageVariants: [],
                url: '/so/',
                image_url: '/logo512.png',
                products_count: 368,
                subcategories_products_count: 368,
                children: [],
            },
            {
                name: '03. Приборы учета, контроля, измерения и оборудование электропитания',
                slug: 'pu',
                imageVariants: [],
                url: '/pu/',
                image_url: '/logo512.png',
                products_count: 354,
                subcategories_products_count: 354,
                children: [],
            },
        ],
    },
    '/categories/modulnoe_oborudovanie/?tree=1': {
        categories: [
            {
                name: 'Модульное оборудование',
                products_count: 1117,
                slug: 'modulnoe_oborudovanie',
                imageVariants: [],
                url: '/modulnoe_oborudovanie/',
                imageUrl: '/logo512.png',
                subcategories_products_count: 1117,
                children: [
                    {
                        name: 'Автоматические выключатели',
                        products_count: 1117,
                        slug: 'avtomaticheskie_vyklyuchateli',
                        imageVariants: [],
                        url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/',
                        imageUrl: '/logo512.png',
                        subcategories_products_count: 0,
                        children: null,
                    },
                ],
            },
        ],
    },
    '/categories/modulnoe_oborudovanie/': {
        categories: [
            {
                name: 'Автоматические выключатели',
                products_count: 1117,
                imageVariants: [],
                slug: 'avtomaticheskie_vyklyuchateli',
                url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/',
                imageUrl: '/logo512.png',
                subcategories_products_count: 0,
                children: [
                    {
                        name: 'Автоматические выключатели KARAT',
                        products_count: 1117,
                        slug: 'avtomaticheskie_vyklyuchateli_karat',
                        imageVariants: [],
                        description: 'блабла',
                        seoText: '<h2>Заголовок</h2><p>Текст</p>',
                        url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/',
                        imageUrl: '/logo512.png',
                        subcategories_products_count: 1117,
                        children: null,
                    },
                ],
            },
        ],
    },
    '/categories/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/?tree=1': {
        categories: [
            {
                name: 'Модульное оборудование',
                products_count: 1117,
                slug: 'modulnoe_oborudovanie',
                imageVariants: [],
                url: '/modulnoe_oborudovanie/',
                imageUrl: '/logo512.png',
                subcategories_products_count: 1117,
                children: [
                    {
                        name: 'Автоматические выключатели',
                        products_count: 1117,
                        imageVariants: [],
                        slug: 'avtomaticheskie_vyklyuchateli',
                        url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/',
                        imageUrl: '/logo512.png',
                        subcategories_products_count: 0,
                        children: [
                            {
                                name: 'Автоматические выключатели KARAT',
                                products_count: 1117,
                                imageVariants: [],
                                slug: 'avtomaticheskie_vyklyuchateli_karat',
                                url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/',

                                description: 'блабла',
                                seoText: '<h2>Заголовок</h2><p>Текст</p>',
                                imageUrl: '/logo512.png',
                                subcategories_products_count: 1117,
                                children: [],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    '/categories/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/': {
        categories: [
            {
                name: 'Автоматические выключатели KARAT',
                products_count: 1117,
                imageVariants: [],
                slug: 'avtomaticheskie_vyklyuchateli_karat',
                url: '/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/',
                description: 'блабла',
                seoText: '<h2>Заголовок</h2><p>Текст</p>',
                imageUrl: '/logo512.png',
                subcategories_products_count: 1117,
                children: [],
            },
        ],
    },
    '/categories/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/?tree=1':
        {
            categories,
        },
    '/categories/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/': {
        categories: [],
    },
    '/categories/new_products': {
        products: popProducts,
    },
    '/categories/popular_products': {
        products: popProducts,
    },
    '/filters/features/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/':
        {
            filters,
        },
    '/filters/features/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/?classId=id0':
        {
            filters,
        },
    '/filters/features/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/?classId=id1':
        {
            filters,
        },
    '/filters/classes/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/':
        {
            classes,
        },
    '/filters/features/': {
        filters,
    },
    '/filters/classes/': {
        classes,
    },
    '/products/modulnoe_oborudovanie/product': {
        product: {
            article: '1LLE-T80-6-230-30-GX53',
            name: 'Лампа светодиодная T75 таблетка 6Вт 230В 3000К GX53 IEK',
            short_name: 'Лампа LED T75 таблетка 6Вт 230В 3000К GX53 IEK',
            tm: 'IEK',
            description:
                'Светодиодные лампы IEK являются современными источниками света и применяются в осветительных приборах, как альтернативные галогенным лампам с цоколем GU5.3, GU10 и лампам накаливания с цоколем Е14, Е27 источники света.\n\nСветодиодные лампы предназначены для использования в осветительных приборах наружного и внутреннего освещения объектов промышленного, коммерческого и бытового назначения.\n\nСоответствуют требованиям Технических регламентов Таможенного союза ТР ТС 004/2011, ТР ТС 020/2011, МЭК 62560, Постановления Правительства РФ от 19.06.2012 № 602.',
            url: '/modulnoe_oborudovanie/product',
            image_urls: ['/logo512.png'],
            imageUrlsVariants: [],
            imageVariants: [],
            video_url: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
            advantages: 'Very bulb\nMuch light\nSuch LED',
            files: [
                {
                    name: 'Сертификаты',
                    files: [
                        { name: 'Отказное письмо ТР ПБ', url: '/' },
                        { name: 'Заказное письмо ТР ПБ', url: '/' },
                    ],
                },
                {
                    name: 'Модели',
                    files: [
                        {
                            type: 'AutoCad',
                            list: [
                                { name: 'Модель А', url: '/' },
                                { name: 'Модель Б', url: '/' },
                            ],
                        },
                        {
                            type: 'ManualCad',
                            list: [
                                { name: 'Модель А', url: '/' },
                                { name: 'Модель Б', url: '/' },
                            ],
                        },
                    ],
                },
            ],
            etim: { features },
            usageParams: features,
            logisticParams: [
                {
                    name: 'Характеристика',
                    id: '1',
                    value: { individual: 200, group: 200, transport: 200 },
                    unit: 'шт',
                    unit_id: null,
                },
                {
                    name: 'Скорость',
                    id: '2',
                    value: { individual: 9000, group: 9001, transport: 9002 },
                    unit: ' км/c',
                    unit_id: null,
                },
            ],
            software: [
                {
                    name: 'Программное обеспечение',
                    description: 'Очень программное обеспечение',
                    url: '/',
                    size: 3_500_000,
                },
            ],
            complects: features,
            designFeatures: Array(10)
                .fill(0)
                .map((_, idx) => ({
                    imageUrl: '/logo512.png',
                    description: 'Описание' + idx,
                    url: '/',
                })),
            analogs: popProducts,
            related: popProducts,
        },
    },
    '/products/modulnoe_oborudovanie/avtomaticheskie_vyklyuchateli/avtomaticheskie_vyklyuchateli_karat/': {
        products: popProducts,
        total: 200,
    },
};
const fakeApi = (url: string, get: GetObject = {}, params: RequestInit = {}) => {
    const fullUrl = Object.keys(get).length ? url + '?' + encodeGet(get) : url;
    const res = methods[fullUrl];
    if (params.body) {
        console.log('request', fullUrl, JSON.parse(params.body as string), res);
    } else {
        console.log('request', fullUrl, res);
    }
    return Promise.resolve(toCamel(res));
};
export default fakeApi;
